export default "__VITE_ASSET__Q_$QLP3q__"